import React, {useState, useEffect, useRef} from 'react';
import {hostUrl, setSpinner, siteUrl, highTrafficInnerPages, invalidUsername, invalidPassword, highTrafficLogin, passwordWeak, passwordMedium, confirPasswordNotMatched } from '../../constants/global';

import { Editor } from '@tinymce/tinymce-react';
import { callPageRenderTracking } from '../common/Helper';


function AddNewTopic() {

    const [useripaddress, setUserIpAddress] =  useState("");
    const [topictitle, setTopicTitle] =  useState("");
    const [topiccontent, setTopicContent] = useState("");
    const [isChecked, setIsChecked] = useState(false);
    const [responsemessage, setResponseMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const editorRef = useRef(null);


    useEffect(() =>{

        callPageRenderTracking({page_title:'Topic Add',page_link:window.location.href});

        /*******add class on body*****/
        document.body.classList.add('white-bg-header');
        return () => {
        document.body.classList.remove('white-bg-header');
        }
    },[]);


    const handleInputChange = (e) => {

        if(e.target.name==="topic-title"){
            setTopicTitle(e.target.value);
        }

        if(e.target.name==="topic-content"){
            setTopicContent(e.target.value);
        }

        if(e.target.name==="add-anonymously"){
            setIsChecked(!isChecked);
        }

    }

    const submitTopic = (e) => {
        e.preventDefault();


        /*******get the user ip address*********/
        fetch('https://geolocation-db.com/json/d802faa0-10bd-11ec-b2fe-47a0872c6708').then(response => {
            return response.json();
        }).then((res) => {
            if(res.IPv4){
                setUserIpAddress(res.IPv4);
            }
        });

        var topiccontenteditor = editorRef.current.getContent();

        /******get data from localstorage*******/
        let authlogin = localStorage.getItem('authlogin');
        let storageData = authlogin ? JSON.parse(authlogin) : "";
        
        var token = 'Bearer '+storageData.token;
        var username = storageData.user_email;

        const data = { callingaction: 'topic_add', title : topictitle , content : topiccontenteditor, anonymously : isChecked, userip: useripaddress };

        const requestOptions = {
                method: 'POST',
                //mode:'cors',
                headers: { 'Content-Type': 'application/json', 
                'POST' : '/resource HTTP/1.1',
                'Authorization': token,
                'Host' : hostUrl,
                'username' : username,
                body: JSON.stringify(data),
                }
            };

        setLoading(true);
        fetch(siteUrl+'/community-rest-functions.php?action=topic_handle',requestOptions)
        .then((response) => response.json())
        .then(function(actualData){ 
            
            setResponseMessage({status:"success",message:"We have send the topic for approval"});
            setTopicTitle("");
            setTopicContent("");
            setIsChecked(false);
            setLoading(false);
       
        }).catch(rejected => {
            setResponseMessage({status:"error",message:highTrafficInnerPages});
        });


    }

  return (
    <div className='fullpage-box'>
    <div className="topic-container">

        <h2 className='page-title'>Add New Topic</h2>

        <form onSubmit={submitTopic}>

            <div className="topic-field">
                <label>Question</label>
                <textarea value={topictitle} name="topic-title" placeholder="Question" onChange={(e) => handleInputChange(e)} required />
            </div>

            <div className="topic-field">
                <label>Description</label>

                <Editor
                    apiKey="r5ixlsvtvg9v4rx95avemaeyvniv0ujxz8na67bi6kydcsx0"
                    onInit={(evt, editor) => editorRef.current = editor}
                    initialValue={topiccontent}
                    init={{
                        height: 400,
                        menubar: false,
                        branding: false,
                        toolbar: 'undo redo | formatselect | ' +
                        'bold italic | alignleft aligncenter ' +
                        'alignright alignjustify | bullist numlist outdent indent | ' +
                        'removeformat',
                        content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                      }}
                />

            </div>

            <div className="topic-checkbox">
                <input type="checkbox" id="add-anonymously" name="add-anonymously" checked={isChecked} onChange={(e) => handleInputChange(e)} />
                <label htmlFor="add-anonymously"> Post Anonymously</label>
                
            </div>


            <div className="back_btn_box">
                <button type="submit" className="submit-topic">{loading && <span class="material-icons-outlined spin">motion_photos_on</span>}Submit</button>
            </div>


            {responsemessage && <div className="response-message">{responsemessage.message}</div>}


        </form>
    </div>
    </div>

  )
}

export default  AddNewTopic